var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCart = function SvgIconCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65.656,
    height: 58.028,
    viewBox: "0 0 65.656 58.028",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    transform: "translate(-1259.794 1742.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(38.209 -2217.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036",
    transform: "translate(1221.585 475.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M1222.349,475.945a.763.763,0,1,0,0,1.526h8.637q5.97,14.872,11.906,29.755l-3.7,8.875a.8.8,0,0,0,.716,1.074h38.176a.764.764,0,1,0,0-1.527h-37.032l3.223-7.707,37.7-3.006a.785.785,0,0,0,.667-.573l4.581-19.852a.8.8,0,0,0-.738-.931h-51.4l-2.862-7.158a.782.782,0,0,0-.716-.477Zm13.361,9.162h17.943v9.926h-13.982Zm19.472,0H1267.4v9.926h-12.215Zm13.742,0h16.608l-2.29,9.926h-14.318Zm-28.632,11.453h13.361v9.114l-9.425.763Zm14.89,0H1267.4v8.017l-12.215.978Zm13.742,0h13.96l-1.6,6.919-12.36.978Zm-21.378,25.2a6.108,6.108,0,1,0,6.108,6.108A6.119,6.119,0,0,0,1247.546,521.757Zm22.905,0a6.108,6.108,0,1,0,6.109,6.108A6.12,6.12,0,0,0,1270.451,521.757Zm-22.905,1.527a4.581,4.581,0,1,1-4.582,4.581A4.569,4.569,0,0,1,1247.546,523.284Zm22.905,0a4.581,4.581,0,1,1-4.581,4.581A4.57,4.57,0,0,1,1270.451,523.284Z",
    transform: "translate(-1221.585 -475.945)",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_cart.a22e9f85.svg";
export { ForwardRef as ReactComponent };